import React from "react";
import { Outlet } from "react-router-dom";
import Footer from "./Footer";
import Header from "./Header";
import { ZALO_LINK } from "../../common/variable";

const Layout = () => {
  return (
    <>
      <Header />
      <Outlet />
      <a href={ZALO_LINK} target="_blank" rel="noopener noreferrer">
        <img src="/img/icon/zalo-icon.svg" className="zalo-icon" />
      </a>
      <Footer />
    </>
  );
};

export default Layout;
